import React from "react";
import { useInstrument } from "../../hooks/useInstruments";
import { useCompanySettings, useTemplateSetting } from "../../hooks/useCompanySettings";
import { DATA_LISTS } from "../../constant/common";
import {TableHeaderFn,TableBodyDataFn} from "../TableDataCreate";
const TickerOverviewContent = ()=> {
  const template = useTemplateSetting();
  const [{ selectedInstrument }] = useInstrument();
  const settings = useCompanySettings();
  const overViewData = settings.enabledDataItems.overView.dataItems;

  return (
    <>
      <div  className="ticker-overview-content" >
        {overViewData.map((data, i) => {
          let list = DATA_LISTS[data];
          let header;
          header = TableHeaderFn(list, header);
          let bindData;
          bindData = TableBodyDataFn(selectedInstrument,list, bindData, "left",template);
          // let bindData = dataChecking(list);
          return (
            <div className="ticker-overview-box" key={i}>
              <div className="ticker-overview-datas">
                <p className="ticker-overview-label">
                  {header[list].children}
                </p>
                <p className="ticker-overview-fielddata">{bindData[list].children }</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default TickerOverviewContent;
